import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TemplateFoldersComponent } from './template-folders.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material.module';
import { PrimeModule } from 'src/app/shared/prime.module';
import { TableToolBarModule } from 'src/app/components/table-tool-bar/table-tool-bar.module';


@NgModule({
	imports: [BrowserAnimationsModule, RouterModule, TranslateModule, CommonModule, MaterialModule, PrimeModule, TableToolBarModule],
	declarations: [TemplateFoldersComponent],
	exports: [TemplateFoldersComponent],
})
export class TemplateFoldersModule {}